const FROM_IOS_APP_KEY = "mem.from.ios.app";

export const writeFromIosApp = (state: boolean) => {
  window.sessionStorage.setItem(FROM_IOS_APP_KEY, String(state));
};

export const readFromIosApp = (): boolean => {
  const state = window.sessionStorage.getItem(FROM_IOS_APP_KEY);
  return state === "true";
};

export const clearFromIosApp = () => {
  window.sessionStorage.removeItem(FROM_IOS_APP_KEY);
};
